import { CommonProp } from '@acin/ui-core';
import React from 'react';
import { useObligationProcesses } from '../hooks/useObligationProcesses';
import * as SC from './ProcessesList.styled';

export interface ProcessesListProps extends CommonProp {
  className?: string;
  selectedObligationId?: string;
}

export const ProcessesList: React.FC<ProcessesListProps> = ({ className, selectedObligationId }) => {
  const { processes, loading, error } = useObligationProcesses(selectedObligationId);

  // Empty state - no obligation selected
  if (!selectedObligationId) {
    return (
      <SC.ProcessesList className={className}>
        <SC.EmptyState>Select an obligation to view its processes</SC.EmptyState>
      </SC.ProcessesList>
    );
  }

  // Loading state
  if (loading) {
    return (
      <SC.ProcessesList className={className}>
        <SC.EmptyState>Loading processes...</SC.EmptyState>
      </SC.ProcessesList>
    );
  }

  // Error state
  if (error) {
    return (
      <SC.ProcessesList className={className}>
        <SC.EmptyState>Error loading processes</SC.EmptyState>
      </SC.ProcessesList>
    );
  }

  // No processes found
  if (processes.length === 0) {
    return (
      <SC.ProcessesList className={className}>
        <SC.EmptyState>No processes found for this obligation</SC.EmptyState>
      </SC.ProcessesList>
    );
  }

  // Render processes list
  return (
    <SC.ProcessesList className={className}>
      <SC.List>
        {processes.map((process) => (
          <SC.Item key={process.id}>
            <SC.ItemName>{process.processName || process.processCode}</SC.ItemName>
            {process.processDescription && <SC.ItemDescription>{process.processDescription}</SC.ItemDescription>}
          </SC.Item>
        ))}
      </SC.List>
    </SC.ProcessesList>
  );
};
